import {Slips} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getSlips(context, pagination) {
        return Slips.getSlips(pagination).then((response) => {
            return response.data;
        });
    },
    getSlip(context, id) {
        return Slips.get({id}).then((response) => {
            return response.data;
        });
    },
    createSlip(context, item) {
        return Slips.create(item).then((response) => {
            return response.data;
        });
    },
    updateSlip(context, item) {
        return Slips.update(item).then((response) => {
            return response.data;
        });
    },
    destroySlip(context, item) {
        return Slips.destroy(item).then((response) => {
            return response.data;
        });
    },
    getSlipStatistics(context, item) {
        return Slips.getSlipStatistics(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
